module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/brands/brands.component.scss
// module id = ./src/app/brands/brands.component.scss
// module chunks = main